export const fr = {
  opportunityRequestModal: {
    //modal states
    event_type_title: 'Choisissez comment vous souhaitez faire du bénévolat',
    event_type_subtitle:
      "Laissez Purposely vous aider à trouver l'opportunité de bénévolat parfaite",
    target_audience_validation: 'Veuillez sélectionner votre type de groupe.',
    event_location_title: 'Choisissez votre lieu',
    event_location_subtitle:
      'Dites-nous où vous souhaitez que cette opportunité ait lieu',
    location_type_validation: "Sélectionnez votre type d'emplacement.",
    event_dates_title: 'Choisissez vos dates et participants',
    event_dates_subtitle:
      'Dites-nous quand vous souhaitez que cette opportunité ait lieu et qui participera',
    dates_validation: 'Veuillez sélectionner au moins 1 date.',
    time_period_validation:
      'Veuillez sélectionner au moins un moment de la journée.',
    event_review_title: "Révisez votre demande d'opportunité",
    event_review_subtitle:
      'Y a-t-il autre chose que vous souhaitez nous faire savoir ?',

    //root index
    error_user_message:
      'Veuillez corriger les erreurs ci-dessous et réessayer.',
    error_description:
      'Cette erreur se produit lorsque les données fournies ne passent pas toutes les validations.',
    error_range: 'Veuillez sélectionner une plage de participants.',
    error_min_and_max: 'Les valeurs minimum et maximum sont requises.',
    error_more_than_one:
      "Le minimum doit être supérieur à 1 personne pour un événement d'équipe. Si vous préférez faire du bénévolat seul, choisissez Solo à l'étape 1.",
    error_min_less_than_max: 'Le minimum doit être inférieur au maximum.',
    error_min_equals_max:
      'Le minimum et le maximum ne peuvent pas être identiques.',
    error_min_max_range:
      'Veuillez maintenir la différence entre le minimum et le maximum de participants dans la limite de 5 personnes.',
    error_location_blank: "Ajoutez un lieu ou sélectionnez 'Virtuel'.",
    greeting: 'Salut ',
    back: 'Retour',
    continue: 'Continuer',
    submit: 'Soumettre',
    of: 'sur',
    to: ' à ',

    //opportunity type step
    solo_description:
      'Faites du bénévolat individuellement pour une cause qui vous tient à cœur. Peut nécessiter de remplir une demande de bénévolat au préalable.',
    team_description:
      'Faites du bénévolat avec votre département ou vos amis. Idéal si vous avez un groupe ou une équipe spécifique en tête.',
    open_group_description:
      "Ouvert à tous les employés de l'entreprise, premier arrivé, premier servi. Parfait pour les bureaux où tous les employés peuvent participer",
    label_solo: 'Solo',
    label_team: 'Équipe',
    label_open_group: 'Groupe Ouvert',

    //location step
    location_type_label: 'Type de lieu',
    location_type_in_person: 'En personne',
    location_type_virtual: 'Virtuel',
    location_label: 'Quelle est la ville préférée ?',
    location_type_virtual_placeholder:
      "Sélectionnez 'En personne' ci-dessus pour ajouter un lieu",
    location_type_in_person_placeholder: 'Trouvez votre ville préférée',
    location_details_label: 'Détails du lieu',
    co_requesters_label: 'Co-organisateur',
    co_requesters_hint: 'Un collègue qui organise avec vous. Il recevra les mêmes mises à jour que vous.',
    co_requesters_add: 'Ajouter un co-organisateur',
    co_requesters_primary: 'Principal',
    co_requesters_you_primary: 'Vous · Principal',
    co_requesters_you: 'Vous',
    co_requesters_added: 'Nous enverrons un courriel à {{name}} dès que vous soumettrez la demande.',
    co_requesters_added_edit: 'Nous enverrons un courriel à {{name}} dès que vous enregistrerez.',
    co_requesters_solo: "Vous faites du bénévolat avec quelqu'un?",
    co_requesters_switch_team: 'Passer à Équipe',
    co_requesters_tooltip: "Votre co-organisateur peut consulter et modifier les détails de la demande et se retirer lui-même. Il reçoit les mêmes courriels que vous. Vous seul pouvez annuler la demande ou le retirer.",
    location_details_in_person_placeholder: 'ex. Centre-ville de Montréal',
    location_type_hint:
      'Vous cherchez un événement virtuel ? Vous pouvez toujours créer le vôtre en choisissant dans notre <0>Marketplace !</0>',

    //dates attendees step
    dates_label: 'Quelles dates vous conviendraient ?',
    dates_hint:
      "Vous ne pouvez pas sélectionner de dates à moins de 4 semaines d'aujourd'hui. Choisir des dates où vous n'êtes pas disponible peut retarder le processus de recherche d'une correspondance.",
    time_period_label: 'Quel(s) moment(s) de la journée conviennent le mieux ?',
    morning: 'Matin',
    afternoon: 'Après-midi',
    evening: 'Soir',
    attendees_label: 'Combien de personnes pensez-vous qui participeront ?',
    unit_label: 'personnes',

    // review step
    opportunity_type: "Type d'opportunité",
    volunteering: 'bénévolat',
    edit: 'Modifier',
    location: 'Lieu',
    none: 'Aucun',
    dates: 'Dates',
    time_of_day: 'Moment de la journée',
    attendees: 'Participants',
    additional_details: 'Détails supplémentaires',
    additional_details_placeholder:
      "ex. 'Nous sommes ouverts à toute opportunité, mais idéalement une où nous travaillons avec la sécurité alimentaire ou les communautés autochtones'",

    //success step
    thanks: 'Merci ',
    update_message: "Votre demande d'opportunité a été ",
    submitted: 'soumise',
    edited: 'modifiée',
    edit_description: 'Vous pouvez modifier votre demande en allant sur la ',
    my_opportunity_requests: 'page Mes événements',
    edit_description_end: ' à tout moment.',
    summary: 'Résumé',
    summary_start: 'Vous ferez du bénévolat',
    summary_team: ' avec une équipe de {{attendees}}',
    whats_next: 'Quelle est la suite ?',
    local_nonprofits:
      "Notre équipe trouvera une opportunité auprès d'organismes locaux à but non lucratif",
    response_time:
      'Nous vous répondrons dans un délai de 1 à 3 semaines avec une opportunité, en privilégiant celles qui arrivent bientôt',
    conclusion:
      "Si cela vous convient, confirmez, et nous créerons une page d'événement pour que vous puissiez vous inscrire",
    edit_request: 'Modifier la demande',
    looks_great: "C'est parfait !",

    //cancel modal
    cancel_changes_title: 'Abandonner vos modifications',
    cancel_request_title: "Annuler la demande d'opportunité",
    cancel_changes_message:
      'Êtes-vous sûr de vouloir abandonner vos modifications ? Votre demande restera telle quelle.',
    cancel_request_message:
      "Êtes-vous sûr de vouloir arrêter ici ? Cette demande n'a pas été soumise et les informations saisies seront perdues.",
  },
}
